import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Drawer, Layout } from "antd";
import { connect } from "react-redux";

import SidebarContent from "./SidebarContent";
import FinanceSidebarContent from "./FinanceSidebarContent";
import PMTSidebarContent from "./PMTSidebarContent"
import { toggleCollapsedSideNav, updateWindowWidth } from "appRedux/actions/Setting";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import './style.css';

const { Sider } = Layout;

const Sidebar = (props) => {
  // console.log("insex sidebar.....................!")
  //console.log(props, 'props......>')

  const dispatch = useDispatch();

  const { themeType, navCollapsed, width, navStyle } = useSelector(({ settings }) => settings);
  const user_role = localStorage.getItem('user_role') ? localStorage.getItem('user_role') : ""
  const loged_in_to = localStorage.getItem('loged_in_to') ? localStorage.getItem('loged_in_to') : ""
  let host;


  const onToggleCollapsedNav = () => {
    dispatch(toggleCollapsedSideNav(!navCollapsed));
  };

  // useEffect(() => {
  //   window.addEventListener('resize', () => {
  //     dispatch(updateWindowWidth(window.innerWidth));
  //   })
  // }, [dispatch]);


  let drawerStyle = "gx-collapsed-sidebar";

  if (navStyle === NAV_STYLE_FIXED) {
    drawerStyle = "";
  } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
    drawerStyle = "gx-mini-sidebar gx-mini-custom-sidebar";
  } else if (navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
    drawerStyle = "gx-custom-sidebar"
  } else if (navStyle === NAV_STYLE_MINI_SIDEBAR) {
    drawerStyle = "gx-mini-sidebar";
  } else if (navStyle === NAV_STYLE_DRAWER) {
    drawerStyle = "gx-collapsed-sidebar"
  }
  if ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR
    || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) && width < TAB_SIZE) {
    drawerStyle = "gx-collapsed-sidebar"
  }

  if (window.location.hostname === "stagingorion22.s3-website.ap-south-1.amazonaws.com") {
    host = 'staging'
  } else if (window.location.hostname === "matrix.uniserved.com") {
    host = 'production'
  } else {
    host = 'local'
  }

  return (
    <Sider
      // style={{ background: '#2f2f2f' , color:'#fff'}}
      className={ host ==='production'?`gx-app-sidebar ${drawerStyle} ${themeType !== THEME_TYPE_LITE ? 'gx-layout-sider-dark' : null}`:`gx-app-sidebar ${drawerStyle} ${themeType !== THEME_TYPE_LITE ? 'gx-layout-sider-dark' : null} custom-sider`}
      trigger={null}
      collapsed={(width < TAB_SIZE ? false : navStyle === NAV_STYLE_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR)}
      theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
      collapsible>
      {
        navStyle === NAV_STYLE_DRAWER || width < TAB_SIZE ?
          <Drawer
            className={`gx-drawer-sidebar ${themeType !== THEME_TYPE_LITE ? 'gx-drawer-sidebar-dark' : null}`}
            placement="left"
            closable={false}
            onClose={onToggleCollapsedNav}
            visible={navCollapsed}>
            {loged_in_to === "pmt" ? (<PMTSidebarContent />) : loged_in_to === "fc" || loged_in_to === "ppl" ? (<FinanceSidebarContent />) : loged_in_to === "orion" ? (<SidebarContent />) : ""}
            {/* {user_role === 'accounts_user' || user_role === 'finance_user' ? (<FinanceSidebarContent/>):
              user_role === 'project_manager' || user_role === 'coordinator' || user_role === 'data_entry' || user_role === 'client_user' || user_role === 'client_admin' || user_role === 'qc' || user_role === 'customer_connect' ? (<PMTSidebarContent/>): (<SidebarContent/> )  } */}
            { }
          </Drawer> :
          loged_in_to === "pmt" ? (<PMTSidebarContent />) : loged_in_to === "fc" || loged_in_to === "ppl" ? (<FinanceSidebarContent />) : loged_in_to === "orion" ? (<SidebarContent />) : ""
        // user_role === 'accounts_user' || user_role === 'finance_user' ? (<FinanceSidebarContent/>):
        // user_role === 'project_manager' || user_role === 'coordinator' || user_role === 'data_entry' || user_role === 'client_user' || user_role === 'client_admin' || user_role === 'qc' || user_role === 'customer_connect'? (<PMTSidebarContent/>) : (<SidebarContent/> )
      }
    </Sider>)
};
const mapStateToProps = ({ auth }) => {
  const { logedInUser } = auth;
  return { logedInUser }
};
export default connect(mapStateToProps,)(Sidebar);
